/* Create org config*/

const { DataTableBase } = require('./base.class');
const { identifiers } = require('../datastructComponents');
const Joi = require('joi');
const { STATES } = require('@bcm/constants');
const { codeSchema } = require('./code.class');

const schema = {
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  orgId: Joi.string().required(),
  maxProviderAP: Joi.string().optional(),
  maxProviderLP: Joi.string().optional(),
  isSecureLinkEnabled: Joi.boolean().optional(),
  isConferenceRoomEnabled: Joi.boolean().optional(),
  isConferenceRoomTranscribeEnabled: Joi.boolean().optional(),
  isConferenceRoomSummarizeEnabled: Joi.boolean().optional(),
  isDictationTranscribeEnabled: Joi.boolean().optional(),
  isDictationSummarizeEnabled: Joi.boolean().optional(),
  // Computationally expensive
  // isWorkspaceEnabled: Joi.boolean().optional(),
  isPatientAccountEnabled: Joi.boolean().optional(),
  isLibraryEnabled: Joi.boolean().optional(),
  isAIAnalysisEnabled: Joi.boolean().optional(),
  isHideGenderIdentity: Joi.boolean().optional(),
  isUnitDefaultMetric: Joi.boolean().optional(),
  supportedConditions: Joi.array().items ( Joi.object().keys( codeSchema ) ).optional(),
};

class OrgConfig extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.orgConfig.buildPk(obj.orgId),
      identifiers.orgConfig.buildSk(obj.state, obj.orgId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.OrgConfig = OrgConfig;
exports.orgConfigSchema = schema;